import React from 'react';
import { Icon, Text } from '@perch-labs/shrike';
import { copyFor } from 'config';
import { getStatementFlagCopy, StatementFlagParams } from 'domain/statement';
import { Wrapper } from './statement-banner.style';

const getCopy = copyFor('billing.statement.banner');

interface Props {
  statement: StatementFlagParams;
  margin?: Margin;
}

export const StatementBanner = ({ statement, margin }: Props) => {
  const copy = getStatementFlagCopy({ statement, getCopy });
  if (!copy) return null;
  return (
    <Wrapper margin={margin} data-testid="statement-banner">
      <Icon
        icon="ExclamationCircleInverted"
        color="warningBright"
        margin={{ right: '8px' }}
      />
      <Text color="warningBright">{copy}</Text>
    </Wrapper>
  );
};
